import { MAIN_PORTAL_PATH } from '../../../routes/paths';
import { PAGE_TITLE } from '../consts';

export interface PageInfo {
  title: PAGE_TITLE;
  hasSubpages: boolean;
}

type Dictionary = Record<MAIN_PORTAL_PATH, PageInfo>;

export const dictionary: Dictionary = {
  [MAIN_PORTAL_PATH.HOME]: {
    title: PAGE_TITLE.HOME,
    hasSubpages: false
  },
  [MAIN_PORTAL_PATH.DASHBOARD]: {
    title: PAGE_TITLE.DASHBOARD,
    hasSubpages: false
  },
  [MAIN_PORTAL_PATH.WALLET]: {
    title: PAGE_TITLE.WALLET,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.ACCOUNT_MANAGEMENT]: {
    title: PAGE_TITLE.USER_MANAGEMENT,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.USSD]: {
    title: PAGE_TITLE.USSD,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.SMS]: {
    title: PAGE_TITLE.SMS,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.OPERATOR_LOOKUP]: {
    title: PAGE_TITLE.OPERATOR_LOOKUP,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.AIRTIME_AND_DATA]: {
    title: PAGE_TITLE.AIRTIME_AND_DATA,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.ACCOUNT_TRANSFERS]: {
    title: PAGE_TITLE.ACCOUNT_TRANSFERS,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.ONDEMAND]: {
    title: PAGE_TITLE.ONDEMAND,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.PAYOUT]: {
    title: PAGE_TITLE.PAYOUT,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.MERCHANT_PAYMENT]: {
    title: PAGE_TITLE.MERCHANT_PAYMENT,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.CUSTOMER_VALIDATION]: {
    title: PAGE_TITLE.CUSTOMER_VALIDATION,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.CUSTOMER_AUTHENTICATION]: {
    title: PAGE_TITLE.CUSTOMER_AUTHENTICATION,
    hasSubpages: true
  },
  [MAIN_PORTAL_PATH.PRODUCTS_AND_SERVICES]: {
    title: PAGE_TITLE.PRODUCTS_AND_SERVICES,
    hasSubpages: false
  }
};
